import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_PROGRAM,
  CREATE_PROGRAM,
  FETCH_PROGRAM,
  FETCH_PROGRAM_LIST,
  UPDATE_PROGRAM,
} from './program.actions';
import { Program, ProgramState } from './program.types';

const getInitialProgramState = (): Program => ({
  id: 0,
  name: '',
  externalId: '',
  isUseNpd: false,
  isHighPriority: false,
  typeOfBusiness: '',
});

const initialState: ProgramState = {
  errorMessage: '',
  item: getInitialProgramState(),
  items: [],
  loading: false,
  totalItems: 0,
};

export default (state: ProgramState = initialState, action: AppAction): ProgramState => {
  switch (action.type) {
    case REQUEST(FETCH_PROGRAM_LIST):
    case REQUEST(CREATE_PROGRAM):
    case REQUEST(FETCH_PROGRAM):
    case REQUEST(UPDATE_PROGRAM):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PROGRAM_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PROGRAM_LIST):
    case FAILURE(CREATE_PROGRAM):
    case FAILURE(FETCH_PROGRAM):
    case FAILURE(UPDATE_PROGRAM):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_PROGRAM):
    case SUCCESS(FETCH_PROGRAM):
    case SUCCESS(UPDATE_PROGRAM):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_PROGRAM:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
